import callAPiBase from './base';
import { REPORTS_TYPES } from 'constants/report';

const employeesSalesApi = {
  getTransactions: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: `/reports?reportType=${REPORTS_TYPES.EMPLOYEE_TRANSACTION}`,
      method: 'GET',
      useToken: true,
      title: 'employeesSales - Get Transactions',
      params,
    }),
  getPayments: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: `/reports?reportType=${REPORTS_TYPES.EMPLOYEE_PAYMENT}`,
      method: 'GET',
      useToken: true,
      title: 'employeesSales - Get Payments',
      params,
    }),
  getResume: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: `/reports?reportType=${REPORTS_TYPES.EMPLOYEE_RESUME}`,
      method: 'GET',
      useToken: true,
      title: 'employeesSales - Get Resume',
      params,
    }),
  getTripResume: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: `/reports?reportType=${REPORTS_TYPES.EMPLOYEE_TRIP_RESUME}`,
      method: 'GET',
      useToken: true,
      title: 'employeesSales - Get Trip Resume',
      params,
    }),
  addPayment: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/employeeAddPayment',
      method: 'POST',
      useToken: true,
      title: 'employeesSales - Add Payment',
      data,
    }),
};

export { employeesSalesApi };
export default employeesSalesApi;
